import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import {
  fetchData,
  hideOrganizationDetails,
  OrganizationDetailsModalAction,
  showOrganizationDetails,
  showOrganizationDetailsAsAdmin,
  submitForm,
  switchToEditMode,
  switchToViewMode,
} from './actions'
import { OrganizationDetailsModalState } from './types'

export const organizationDetailsModalReducer = combineReducers<
  OrganizationDetailsModalState,
  OrganizationDetailsModalAction
>({
  show: (show = false, action) => {
    switch (action.type) {
      case getType(showOrganizationDetails):
      case getType(showOrganizationDetailsAsAdmin):
        return true
      case getType(hideOrganizationDetails):
        return false
      default:
        return show
    }
  },
  isAdmin: (isAdmin = false, action) => {
    switch (action.type) {
      case getType(showOrganizationDetailsAsAdmin):
        return true
      case getType(showOrganizationDetails):
      case getType(hideOrganizationDetails):
        return false
      default:
        return isAdmin
    }
  },
  isLoading: (isLoading = false, action) => {
    switch (action.type) {
      case getType(fetchData.request):
        return true
      case getType(fetchData.success):
      case getType(fetchData.failure):
        return false
      default:
        return isLoading
    }
  },
  isInEditMode: (isInEditMode = false, action) => {
    switch (action.type) {
      case getType(switchToEditMode):
        return true
      case getType(switchToViewMode):
      case getType(submitForm.success):
      case getType(showOrganizationDetails):
      case getType(showOrganizationDetailsAsAdmin):
        return false
      default:
        return isInEditMode
    }
  },
  isSubmitting: (isSubmitting = false, action) => {
    switch (action.type) {
      case getType(submitForm.request):
        return true
      case getType(submitForm.failure):
      case getType(submitForm.success):
        return false
      default:
        return isSubmitting
    }
  },
  dealId: (dealId = null, action) => {
    switch (action.type) {
      case getType(fetchData.request):
      case getType(fetchData.failure):
        return null
      case getType(fetchData.success):
        return action.payload.dealId || null
      default:
        return dealId
    }
  },
  organizationId: (organizationId = null, action) => {
    switch (action.type) {
      case getType(fetchData.request):
      case getType(fetchData.failure):
        return null
      case getType(fetchData.success):
        return action.payload.organizationId || null
      default:
        return organizationId
    }
  },
})
